import { Component } from '@angular/core';

@Component({
  selector: 'dashboard-base-component',
  template: '',
})
export abstract class DashboardBaseComponent {
  isLoaded = false;
}
